/* PLUMELLE: Cookiebot PDP — run first-party Rubik copies before Allow
   (Cookiebot auto-blocks the app CDN URLs). Pad buy box above the sheet. */
(function () {
  if (window.__plumelleCookiebotPdpRubik) return;
  window.__plumelleCookiebotPdpRubik = true;

  var MARK = 'data-plumelle-rubik-ignore';
  var started = false;
  var flushTimer = null;

  function assetList() {
    var list = window.PLUMELLE_RUBIK_ASSETS;
    return list && list.length ? list : [];
  }

  function canFlush() {
    return !!(window.RubikSwatchConfig && document.querySelector('variant-radios, variant-selects') && assetList().length);
  }

  function moveSwatchIntoPicker() {
    var swatch = document.querySelector('rubik-swatch');
    var host = document.querySelector('.product-parameters');
    if (!swatch || !host) return;
    if (host.contains(swatch)) return;
    host.insertBefore(swatch, host.firstChild);
  }

  function disarmAppCopies() {
    var nodes = document.querySelectorAll('script[src*="rubik-variant-images"]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!/(?:swatch-component|swatch|theme_madrid)\.js/i.test(el.src || '')) continue;
      el.setAttribute(MARK, '1');
      el.type = 'text/plain';
      el.setAttribute('data-cookieconsent', 'ignore');
    }
  }

  function runInline(code) {
    var n = document.createElement('script');
    n.setAttribute('data-cookieconsent', 'ignore');
    n.setAttribute(MARK, '1');
    n.text = code;
    try {
      (document.head || document.documentElement).appendChild(n);
    } catch (e) {}
  }

  function loadSrc(src, done) {
    fetch(src, { credentials: 'same-origin', cache: 'force-cache' })
      .then(function (r) {
        if (!r.ok) throw new Error('rubik-fetch');
        return r.text();
      })
      .then(function (code) {
        try {
          runInline(code);
        } catch (e) {}
        done();
      })
      .catch(function () {
        var n = document.createElement('script');
        n.src = src;
        n.async = false;
        n.setAttribute('data-cookieconsent', 'ignore');
        n.setAttribute(MARK, '1');
        n.onload = done;
        n.onerror = done;
        (document.head || document.documentElement).appendChild(n);
      });
  }

  function loadAll(list, index) {
    if (index >= list.length) {
      disarmAppCopies();
      moveSwatchIntoPicker();
      setTimeout(moveSwatchIntoPicker, 300);
      setTimeout(moveSwatchIntoPicker, 1200);
      return;
    }
    loadSrc(list[index], function () {
      loadAll(list, index + 1);
    });
  }

  function flush() {
    if (started || !canFlush()) return;
    started = true;
    if (flushTimer) {
      clearInterval(flushTimer);
      flushTimer = null;
    }
    loadAll(assetList(), 0);
  }

  function scheduleFlush() {
    flush();
    if (started || flushTimer) return;
    flushTimer = setInterval(flush, 100);
  }

  scheduleFlush();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleFlush);
  }
  window.addEventListener('CookiebotOnAccept', disarmAppCopies);
  window.addEventListener('CookiebotOnDecline', disarmAppCopies);
})();

(function () {
  if (window.__plumelleCookiebotPdpPad) return;
  window.__plumelleCookiebotPdpPad = true;

  var lastH = -1;
  var scrolledFor = -1;
  var dialogObs = null;

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function dialogEl() {
    return document.querySelector('#CybotCookiebotDialog');
  }

  function dialogHeight() {
    if (!isMobile()) return 0;
    var el = dialogEl();
    if (!el) return 0;
    var s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return 0;
    var h = el.getBoundingClientRect().height;
    return h > 1 ? Math.ceil(h) : 0;
  }

  function padTargets() {
    return document.querySelectorAll('.product__info-container');
  }

  function visRect(el) {
    if (!el) return null;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden') return null;
    var b = el.getBoundingClientRect();
    if (b.height < 1) return null;
    return b;
  }

  function buyCluster() {
    var top = Infinity;
    var bottom = 0;
    var pickers = document.querySelectorAll(
      '.product__info-container rubik-swatch, .plumelle-size-price-select'
    );
    for (var i = 0; i < pickers.length; i++) {
      var b = visRect(pickers[i]);
      if (!b) continue;
      if (b.top < top) top = b.top;
      if (b.bottom > bottom) bottom = b.bottom;
    }
    if (!isFinite(top)) return null;
    return { top: top, bottom: bottom, height: bottom - top };
  }

  function atcRect() {
    return visRect(
      document.querySelector(
        '.product__buy_buttons button[name="add"], .product__info-container button[name="add"]'
      )
    );
  }

  function watchDialog(el) {
    if (!el || dialogObs) return;
    try {
      dialogObs = new MutationObserver(schedule);
      dialogObs.observe(el, { attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true });
    } catch (e) {}
    if (window.ResizeObserver) {
      try {
        new ResizeObserver(schedule).observe(el);
      } catch (e2) {}
    }
  }

  function apply() {
    var el = dialogEl();
    if (el) watchDialog(el);
    var h = dialogHeight();
    var targets = padTargets();
    if (h !== lastH || (h > 0 && targets.length && !targets[0].style.paddingBottom)) {
      lastH = h;
      for (var i = 0; i < targets.length; i++) {
        targets[i].style.paddingBottom = h > 0 ? h + 'px' : '';
      }
    }
    if (h < 1) {
      scrolledFor = -1;
      return;
    }
    if (scrolledFor === h) return;
    if (
      !document.querySelector('.product__info-container rubik-swatch') &&
      !document.querySelector('.plumelle-size-price-select')
    ) {
      return;
    }
    var header = document.querySelector('.header, sticky-header, #shopify-section-header');
    var headerBottom = header ? header.getBoundingClientRect().bottom : 0;

    function lift(bottom, top) {
      var dTop = el.getBoundingClientRect().top;
      var need = Math.ceil(bottom - dTop + 8);
      if (need > 0 && top - need >= headerBottom - 4) {
        window.scrollBy(0, need);
        return true;
      }
      return need <= 0;
    }

    var box = buyCluster();
    if (!box) return;
    lift(box.bottom, box.top);
    var ab = atcRect();
    if (ab) {
      box = buyCluster();
      var top = box ? Math.min(box.top, ab.top) : ab.top;
      lift(ab.bottom, top);
    }
    scrolledFor = h;
  }

  function schedule() {
    apply();
  }

  function start() {
    document.documentElement.setAttribute('data-plumelle-cb-pad', '1');
    schedule();
    window.addEventListener('resize', schedule);
    window.addEventListener('CookiebotOnDialogDisplay', schedule);
    window.addEventListener('CookiebotOnAccept', schedule);
    window.addEventListener('CookiebotOnDecline', schedule);
    var n = 0;
    var poll = setInterval(function () {
      schedule();
      n += 1;
      if (n > 40) clearInterval(poll);
    }, 250);
    try {
      new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
